import * as React from 'react';
import { DataLayer } from '@grandvisionhq/analytics';
import { useDrawer, RowTrigger } from '@grandvisionhq/common';
import { REVIEWS_HASH } from '@grandvisionhq/reviews';
import { useHashNavigation } from '@grandvisionhq/utils';

const ProductDetailReviewsCTA = ({ title  })=>{
    const { toggle , isOpen , open  } = useDrawer();
    const { hash , clearHash  } = useHashNavigation();
    const previousIsOpen = React.useRef(isOpen);
    React.useEffect(()=>{
        if (!hash) {
            return;
        }
        if (hash.includes(REVIEWS_HASH) && previousIsOpen.current === false) {
            open();
        }
        // we need to check previous value of isOpen for clean up of hash in the url
        if (hash.includes(REVIEWS_HASH) && previousIsOpen.current === true) {
            clearHash();
        }
        previousIsOpen.current = isOpen;
    }, [
        clearHash,
        hash,
        isOpen,
        open
    ]);
    const handleClick = ()=>{
        DataLayer.Events.pushDrawerEventToDataLayer({
            siteFeature: 'reviews',
            interactionType: 'reviews_click'
        });
        toggle();
    };
    return /*#__PURE__*/ React.createElement(RowTrigger, {
        title: title,
        onClick: handleClick,
        "data-t": "reviews-drawer-trigger"
    });
};

export { ProductDetailReviewsCTA };
//# sourceMappingURL=ProductDetailReviewsCTA.js.map
